//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function createCompanyService (formData) {
  try {
    await api.post("/empresas", formData);
    toast.success("Empresa criada com sucesso!");
    return true;
  } catch (error) {
    toast.error("Erro ao criar empresa!");
    return false;
  }
}